document.addEventListener("DOMContentLoaded", function () {
  // Set the ignoreRepeatedEmails variable
  let ignoreRepeatedEmails = false;

  // Maximum number of gift cards that can be ordered
  const maxRecipients =
    parseInt(document.getElementById("maxGiftcards").value) || 100;

  // Gift card product handle
  const giftCardProductHandle = document.getElementById("productHandle").value;

  // Checkbox email options
  const useSameEmailCheckbox = document.getElementById("singleEmailOption");
  const useMultipleEmailsCheckbox = document.getElementById(
    "multipleEmailsOption"
  );

  // Initialize the app
  function init() {
    // Add event listeners and remove loading animation
    addEventListeners();
    document.getElementById("loading").classList.add("hide");
  }

  function addEventListeners() {
    // Prevent manually inputting more than the max value
    document
      .getElementById("giftCardCount")
      .addEventListener("input", function () {
        const max = parseFloat(this.max);
        const value = parseFloat(this.value);

        if (value > max) {
          this.value = max; // Set to max if value exceeds it
        }
      });
    // Add event listener to the Proceed button
    document
      .getElementById("proceedButton")
      .addEventListener("click", function (event) {
        event.preventDefault();
        // Get the number of gift cards from the input
        const count =
          parseInt(document.getElementById("giftCardCount").value) || 1;

        // Get the div where email inputs will be added
        const listOfRecipients = document.getElementById("listOfRecipients");

        // Clear previous inputs
        listOfRecipients.innerHTML = "";

        // Create the email input fields
        const totalRecipients = Math.min(count, maxRecipients);
        if (count >= maxRecipients) {
          // Do not show add more button if limit reached.
          document.getElementById("addMoreRecipients").classList.add("hide");
        }
        for (let i = 0; i < totalRecipients; i++) {
          const recipientDiv = document.createElement("div");
          recipientDiv.classList.add("recipient-input");
          if (i !== 0) {
            recipientDiv.classList.add("hide");
          }

          const emailLabel = document.createElement("label");
          emailLabel.textContent =
            "Vastaanottajan sähköpostiosoite";
          emailLabel.classList.add("email-label");

          const emailInput = document.createElement("input");
          emailInput.type = "email";
          emailInput.name = "email";
          emailInput.id = `recipientEmail_${i}`;
          emailInput.required = true;

          // Append input to label, and label to the recipient div
          emailLabel.appendChild(emailInput);
          recipientDiv.appendChild(emailLabel);
          listOfRecipients.appendChild(recipientDiv);

          // Add close button to remove the email input
          if (count > 1) {
            const close = document.createElement("button");
            close.textContent = "X";
            close.type = "button";
            close.classList.add("close-button");
            close.setAttribute(
              "aria-label",
              "Poista vastaanottaja"
            );
            close.addEventListener("click", function () {
              recipientDiv.remove();
              // Remove the close-button if only one recipient input left.
              if (listOfRecipients.children.length === 1) {
                listOfRecipients.children[0]
                  .querySelector(".close-button")
                  .remove();
              }
              // Show the addMoreRecipients button if the number of inputs is below the limit
              if (listOfRecipients.children.length < maxRecipients) {
                document
                  .getElementById("addMoreRecipients")
                  .classList.remove("hide");
              }
              // Update the IDs of the remaining email inputs
              Array.from(listOfRecipients.children).forEach((child, index) => {
                const emailInput = child.querySelector("input[type='email']");
                emailInput.id = `recipientEmail_${index}`;
              });
              // update the counter
              document.querySelector("[data-quantity]").textContent =
                listOfRecipients.children.length;
            });
            recipientDiv.appendChild(close);
          }

          // Remove .hide from #otherOptions
          document.getElementById("otherOptions").classList.remove("hide");
          // Add .hide to #options
          document.getElementById("options").classList.add("hide");
        }
        // Set the initial state of email inputs
        setTimeout(() => {
          useSameEmailCheckbox.dispatchEvent(new Event("change"));
        }, 300);
      });

    // Add event listener to the addRecipient button
    document
      .getElementById("addMoreRecipients")
      .addEventListener("click", function (event) {
        event.preventDefault();
        addMoreRecipientInputs();
      });

    // Add event listener to the file input
    document
      .getElementById("recipients-sheet")
      .addEventListener("change", handleFile, false);

    // Add event listener to giftCardCount and update the value of the quantity span
    document
      .getElementById("giftCardCount")
      .addEventListener("input", function () {
        document.querySelector("[data-quantity]").textContent = this.value;
      });

    // Add event listener to the VariantSelector and update the price span
    document
      .getElementById("VariantSelector")
      .addEventListener("change", function () {
        const selectedVariant = this.options[this.selectedIndex];
        document.querySelector("[data-price]").textContent =
          selectedVariant.getAttribute("data-variant-price");
      });

    // Add event listeners to both radio buttons to handle email input visibility
    let syncEmailListener = null;

    function handleEmailOptionChange() {
      const emailInputs = document.querySelectorAll(
        "#listOfRecipients input[type='email']"
      );
      const addMoreBtn = document.getElementById("addMoreRecipients");
      const isSingleEmail = useSameEmailCheckbox.checked;

      if (isSingleEmail) {
        // show .sameEmailForAll and hide .multipleEmails
        document.getElementById("multipleEmails").classList.add("hide");
        // Hide all but the first input and sync values
        emailInputs.forEach((input, idx) => {
          if (idx === 0) {
            input.parentElement.parentElement.classList.remove("hide");
          } else {
            input.parentElement.parentElement.classList.add("hide");
            input.value = emailInputs[0].value;
          }
        });
        // Add listener to first input to sync value
        syncEmailListener = function () {
          emailInputs.forEach((input, idx) => {
            if (idx !== 0) input.value = emailInputs[0].value;
          });
        };
        emailInputs[0].addEventListener("input", syncEmailListener);
        // hide addMoreRecipients
        if (addMoreBtn) addMoreBtn.classList.add("hide");
        // disable close-button on first input
        const closeButtons = document.querySelectorAll(
          "#listOfRecipients .recipient-input .close-button"
        );
        if (closeButtons.length > 0) {
          closeButtons[0].classList.add("hide");
        }
      } else {
        // show .multipleEmails and hide .sameEmailForAll
        document.getElementById("multipleEmails").classList.remove("hide");
        // Show all inputs and clear others except the first
        emailInputs.forEach((input, idx) => {
          input.parentElement.parentElement.classList.remove("hide");
          if (idx !== 0) input.value = "";
        });
        // Remove sync listener
        if (syncEmailListener) {
          emailInputs[0].removeEventListener("input", syncEmailListener);
          syncEmailListener = null;
        }
        // show addMoreRecipients if below limit
        if (emailInputs.length < maxRecipients) {
          if (addMoreBtn) addMoreBtn.classList.remove("hide");
        }
        // enable close-button on first input if more than one input exists
        if (emailInputs.length > 1) {
          const closeButtons = document.querySelectorAll(
            "#listOfRecipients .recipient-input .close-button"
          );
          if (closeButtons.length > 0) {
            closeButtons[0].classList.remove("hide");
          }
        }
      }
    }

    useSameEmailCheckbox.addEventListener("change", handleEmailOptionChange);
    useMultipleEmailsCheckbox.addEventListener(
      "change",
      handleEmailOptionChange
    );

    // Add event listener to the reset button
    document
      .getElementById("resetButton")
      .addEventListener("click", function (event) {
        event.preventDefault();
        // Reset the personalized message input
        document.getElementById("personalizedMessage").value = "";
        // Clear the email inputs
        document.getElementById("listOfRecipients").innerHTML = "";
        // Reset the file input
        document.getElementById("recipients-sheet").value = "";
        // Reset the file name display
        document.getElementById("fileName").textContent = ".xlsx, .xls, .csv";
        // Reset the quantity input
        document.getElementById("giftCardCount").value = 1;
        document.querySelector("[data-quantity]").textContent = 1;
        // Reset the variant selector
        document.getElementById("VariantSelector").selectedIndex = 0;
        // Reset the price span
        const selectedVariant =
          document.getElementById("VariantSelector").options[0];
        document.querySelector("[data-price]").textContent =
          selectedVariant.textContent;
        // Remove .hide from #options
        document.getElementById("options").classList.remove("hide");
        // Add .hide to #otherOptions
        document.getElementById("otherOptions").classList.add("hide");
        // remove all error messages
        removeErrorMessages();
      });

    // Add event listener to the orderSubmit button
    document
      .getElementById("orderSubmit")
      .addEventListener("click", function (event) {
        event.preventDefault();
        this.classList.add("is-hidden");
        removeErrorMessages();
        // Get the form element
        const form = document.getElementById("giftcardsOrderForm");
        // Get the email addresses from the form
        const formData = new FormData(form);
        const recipientsEmailAddresses = formData.getAll("email");
        const variantId = document.getElementById("VariantSelector").value;
        const personalizedMessage = document.getElementById(
          "personalizedMessage"
        ).value;

        setTimeout(() => {
          validateFormInputs(
            recipientsEmailAddresses,
            variantId,
            personalizedMessage
          );
        }, 100);
      });

    // Add event listener to the ignoreRepeatedEmails button.
    document
      .getElementById("contactRepeatedContinueButton")
      .addEventListener("click", function (event) {
        event.preventDefault();
        ignoreRepeatedEmails = true;
        document.getElementById("orderSubmit").click();
      });
    // Add event listener to the contactRepeatedCancelButton
    document
      .getElementById("contactRepeatedCancelButton")
      .addEventListener("click", function (event) {
        event.preventDefault();
        document
          .getElementById("giftcards_order_contact_repeated")
          .classList.add("hidden");
        document.getElementById("orderSubmit").classList.remove("is-hidden");
      });
  }

  function addMoreRecipientInputs() {
    const listOfRecipients = document.getElementById("listOfRecipients");

    // Check if the number of recipient inputs has reached the maximum limit
    if (listOfRecipients.children.length >= maxRecipients) {
      console.log("Maximum number of recipients reached");
      document.getElementById("addMoreRecipients").classList.add("hide");
      return;
    }

    const recipientDiv = document.createElement("div");
    recipientDiv.classList.add("recipient-input");

    const emailLabel = document.createElement("label");
    emailLabel.textContent =
      "Vastaanottajan sähköpostiosoite";
    emailLabel.classList.add("email-label");

    const emailInput = document.createElement("input");
    emailInput.type = "email";
    emailInput.name = "email";
    emailInput.required = true;

    // Determine the next index for the email input id
    const lastInput = listOfRecipients.querySelector(
      ".recipient-input:last-child input"
    );
    const nextIndex = lastInput ? parseInt(lastInput.id.split("_")[1]) + 1 : 0;
    emailInput.id = `recipientEmail_${nextIndex}`;

    emailLabel.appendChild(emailInput);
    recipientDiv.appendChild(emailLabel);

    const close = document.createElement("button");
    close.textContent = "X";
    close.type = "button";
    close.classList.add("close-button");
    close.setAttribute(
      "aria-label",
      "Poista vastaanottaja"
    );
    close.addEventListener("click", function () {
      recipientDiv.remove();
      if (listOfRecipients.children.length === 1) {
        listOfRecipients.children[0].querySelector(".close-button").remove();
      }
      // Show the addMoreRecipients button if the number of inputs is below the limit
      if (listOfRecipients.children.length < maxRecipients) {
        document.getElementById("addMoreRecipients").classList.remove("hide");
      }
      // update the counter
      document.querySelector("[data-quantity]").textContent =
        listOfRecipients.children.length;
    });

    recipientDiv.appendChild(close);
    listOfRecipients.appendChild(recipientDiv);

    // Hide the addMoreRecipients button if the number of inputs reaches the limit
    if (listOfRecipients.children.length >= maxRecipients) {
      document.getElementById("addMoreRecipients").classList.add("hide");
    }

    // update the counter
    document.querySelector("[data-quantity]").textContent =
      listOfRecipients.children.length;
  }

  function validateFormInputs(
    recipientsEmailAddresses,
    variantId,
    personalizedMessage
  ) {
    // check if the email addresses are valid
    if (recipientsEmailAddresses.some((email) => !validateEmail(email))) {
      console.log("Email addresses are invalid");
      document
        .getElementById("giftcards_order_contact_invalid_format")
        .classList.remove("hidden");
      document.querySelectorAll('input[type="email"]').forEach((input) => {
        if (!validateEmail(input.value)) {
          input.classList.add("is-invalid-input");
        }
      });
      document.getElementById("orderSubmit").classList.remove("is-hidden");
      return;
      // check if the personalized message is too long
    } else if (personalizedMessage.length > 200) {
      document
        .getElementById("personalized_message_too_long")
        .classList.remove("hidden");
      document
        .getElementById("personalizedMessage")
        .classList.add("is-invalid-input");
      document.getElementById("orderSubmit").classList.remove("is-hidden");
      return;
      // check if terms have been accepted #giftcards_order_terms
    } else if (!document.getElementById("giftcards_order_terms").checked) {
      console.log("Terms have not been accepted");
      document
        .getElementById("giftcards_order_terms_not_accepted")
        .classList.remove("hidden");
      document
        .getElementById("giftcards_order_terms")
        .classList.add("is-invalid-input");
      document.getElementById("orderSubmit").classList.remove("is-hidden");
      return;
    } else if (checkForRepeatedEmails(recipientsEmailAddresses)) {
      // Some email address is repeated
      console.log("Email addresses are repeated");
      return;
    } else if (grecaptcha.getResponse() === "") {
      console.log("Captcha not completed");
      document
        .getElementById("giftcards_order_missing_required_fields")
        .classList.remove("hidden");
      document.getElementById("orderSubmit").classList.remove("is-hidden");
      return;
    } else {
      processGiftCardsOrder(
        recipientsEmailAddresses,
        variantId,
        personalizedMessage
      );
    }
  }

  function validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  // Function to check which emails are repeated then highlight them and show an error message
  function checkForRepeatedEmails(emails) {
    // if useSameEmailForAll check is enabled, we don't need to check for repeated emails
    if (useSameEmailCheckbox.checked) {
      return false;
    }
    if (ignoreRepeatedEmails) {
      return false;
    }
    const repeatedEmails = emails.filter(
      (email, index) => emails.indexOf(email) !== index
    );
    if (repeatedEmails.length) {
      document
        .getElementById("giftcards_order_contact_repeated")
        .classList.remove("hidden");
      repeatedEmails.forEach((email) => {
        const inputs = document.querySelectorAll('input[name="email"]');
        inputs.forEach((input) => {
          if (input.value === email) {
            input.classList.add("is-invalid-input");
          }
        });
      });
      return true;
    }
    return false;
  }

  function removeErrorMessages() {
    document
      .querySelectorAll(".form-errors")
      .forEach((el) => el.classList.add("hidden"));
    document
      .querySelectorAll(".is-invalid-input")
      .forEach((input) => input.classList.remove("is-invalid-input"));
  }

  // Function to handle the file upload
  function handleFile(event) {
    const file = event.target.files[0];
    if (!file) return; // Check if a file is selected

    // Display the file name next to the upload button
    document.getElementById("fileName").textContent = `${file.name}`;

    const reader = new FileReader();

    reader.onload = function (e) {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Get the first sheet and extract its data
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      // Convert the sheet data to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Assume email addresses are in the first column
      const recipients = jsonData.map((row) => row[0]).filter((email) => email);

      // Populate inputs with extracted email addresses
      recipients.forEach((email, index) => {
        const emailInput = document.getElementById(`recipientEmail_${index}`);
        if (emailInput) {
          emailInput.value = email;
        }
      });
    };

    reader.readAsArrayBuffer(file);
  }

  // create the formData object with one item per email address. Email address is stored in the properties object.
  function processGiftCardsOrder(
    recipientsEmailAddresses,
    variantId,
    personalizedMessage
  ) {
    let formData = {
      items: [],
    };
    recipientsEmailAddresses.forEach((email) => {
      formData.items.push({
        id: variantId,
        quantity: 1,
        properties: {
          _handle: "lahjakortti",
          _availability_code: "",
          _availability_text: "",
          _not_buyable: "false",
          _product_language: "",
          _recipient_email: email,
          "Vastaanottaja": email, // Recipient email for displaying at checkout.
          _message: personalizedMessage,
        },
      });
    });
    addToCart(formData);
  }

  // Add the gift cards to the cart
  function addToCart(formData) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          document
            .getElementById("giftcards_order_success")
            .classList.remove("is-hidden");
          document.getElementById("giftcards-main").classList.add("hide-form");
          // scrool to the success message
          document
            .getElementById("giftcards_order_success")
            .scrollIntoView({ behavior: "smooth", block: "start" });
          window.scrollBy(0, -250);
          // Refresh the mini-sidecart
          woolman.getAndBuildCart();
          $("[data-off-canvas-cart]").foundation("open");
          console.log("Success:", response);
        } else {
          return response.json().then((data) => {
            // Display the error message
            document.getElementById("generic-error").classList.remove("hidden");
            console.error("Error:", data);
          });
        }
      })
      .catch((error) => {
        document.getElementById("generic-error").classList.remove("hidden");
        console.error("Error:", error);
      });
  }

  // Call the init function
  setTimeout(() => {
    init();
  }, 1000);
});
